const getUserStorageName = (user) => {
  const { storageType = 'gd', picsioStorage } = user;
  if (picsioStorage) return 'picsioStorage';
  return storageType;
};

export default getUserStorageName;
